import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bulkDownloadJob, bulkDownloadPortraitsJob } from 'ducks';
import { connect } from 'react-redux';
import BulkUserJobModal from './BulkUserJobModal';
import Routes from '../../../../routes';

const BulkDownload = ({
  data,
  type,
  download,
  poll,
  cancel,
  onClose
}) => {
  const [job, setJob] = useState(null);
  const [downloadLink, setDownloadLink] = useState();

  const handleClose = () => (job && job.status === 'pending' ? cancel() : onClose());
  const onSubmit = () => {
    return new Promise((resolve, reject) => {
      download({ type, data })
        .then(resp => {
          setJob(resp);
          poll(resp)
            .then(pollResp => {
              setDownloadLink(Routes.api_user_jobs_job_attachment_path(type, pollResp.id));
              setJob(pollResp);
              resolve();
            })
            .catch(pollResp => {
              setJob(null);
              if (pollResp.status === 'cancelled') {
                onClose();
              } else {
                reject();
              }
            });
        })
        .catch(() => {
          setJob(null);
          reject();
        });
    });
  };

  return (
    <BulkUserJobModal
      autoSubmit
      className='bulk-download-modal'
      workingTitle='Download File'
      completedTitle='Download File'
      onClose={handleClose}
      onSubmit={onSubmit}
      downloadLink={downloadLink}
    />
  );
};

BulkDownload.propTypes = {
  /** Job Data */
  data: PropTypes.shape({}).isRequired,

  /** Job Type */
  type: PropTypes.string,

  /** Dispatches an action to start the PDF Generation job */
  download: PropTypes.func.isRequired,

  /** Dispatches an action to poll the status of the PDF Job */
  poll: PropTypes.func.isRequired,

  /** Cancells a poll action for cleanup */
  cancel: PropTypes.func.isRequired,

  /** Function to close and unmount this component */
  onClose: PropTypes.func.isRequired
};

BulkDownload.defaultProps = {
  type: 'bulk_download_job'
};

const selectDuck = (type) => {
  switch (type) {
    case 'bulk_download_portraits_job':
      return bulkDownloadPortraitsJob;
    case 'bulk_download_job':
      return bulkDownloadJob;
    default:
      return bulkDownloadJob;
  }
};

const mapDispatchToProps = (dispatch, { type }) => {
  const duck = selectDuck(type);
  return {
    download: job => dispatch(duck.actions.create(job)).then(duck.actions.denormalizeObjects),
    poll: job => dispatch(duck.actions.poll(job)).then(duck.actions.denormalizeObjects),
    cancel: () => dispatch(duck.actions.cancelPoll())
  };
};

export default connect(null, mapDispatchToProps)(BulkDownload);
